import InternationalBankModel from './international-bank-model';

export default class CustomerInternationalBankModel extends InternationalBankModel {
  constructor(obj) {
    obj = obj || {};
    super(obj);

    this.id = obj.id;
    this.integrationStatuses = obj.integrationStatuses || [];
  }
}